import PropTypes from 'prop-types';

export const legacyServerContextProps = PropTypes.shape({
  // Required
  CurrentLocale: PropTypes.string.isRequired,
  PageTrackingId: PropTypes.string.isRequired,
  ServicesEndpoints: PropTypes.shape({
    AdInsightAPI: PropTypes.string,
    CampaignAPI: PropTypes.string.isRequired,
  }).isRequired,
  CampaignAPIPath: PropTypes.string.isRequired,

  // Not Required (e.g. not logged in yet)
  CurrentUser: PropTypes.shape({
    UserId: PropTypes.number,
    UserName: PropTypes.string,
    Email: PropTypes.string,
    Lcid: PropTypes.number,
    CustomerMarket: PropTypes.string,
  }),
  CurrentCustomer: PropTypes.shape({
    CustomerId: PropTypes.number.isRequired,
    CustomerNumber: PropTypes.string.isRequired,
    CustomerName: PropTypes.string.isRequired,
  }),
  CurrentAccount: PropTypes.shape({
    AccountId: PropTypes.number.isRequired,
    AccountNumber: PropTypes.string.isRequired,
    AdvertiserCustomerId: PropTypes.number,
    AccountMode: PropTypes.number,
    LifecycleStatus: PropTypes.number,
    CurrencyType: PropTypes.string,
    CountryCode: PropTypes.string,
  }),
  Token: PropTypes.string,
  CCBaseUrl: PropTypes.string.isRequired,
  PidlConfiguration: PropTypes.shape({
    PidlEnvironment: PropTypes.string.isRequired,
    PidlEnabledCountries: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    ExcludedCountriesByCardType: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    ThreatMetrixUrl: PropTypes.string.isRequired,
    MsaDelegateAuthUrl: PropTypes.string.isRequired,
    PidlErrorFormattingStrings: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    PidlSupportedCultureMapping: PropTypes.objectOf(PropTypes.string).isRequired,
    FriendlySepaMaxNameLength: PropTypes.number.isRequired,
  }).isRequired,
  CCUIPilots: PropTypes.objectOf(PropTypes.bool).isRequired,
  PaymentInstrumentConfigs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    supportedPaymentType: PropTypes.number,
    supportedCurrencies: PropTypes.arrayOf(PropTypes.string.isRequired),
    useSupportedCountryList: PropTypes.bool.isRequired,
    supportedCountries: PropTypes.arrayOf(PropTypes.string.isRequired),
  })).isRequired,
  AuthType: PropTypes.string.isRequired,
  CookieDomain: PropTypes.string.isRequired,
  CookiePath: PropTypes.string.isRequired,
});

export const serverContextProps = PropTypes.shape({
  CurrentAccount: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    AccountNumber: PropTypes.string.isRequired,
    AdvertiserCustomerID: PropTypes.number,
    CurrencyCode: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
    Number: PropTypes.string.isRequired,
    Status: PropTypes.number,
  }),
  CurrentCustomer: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }),
  CurrentLocale: PropTypes.string.isRequired,
  CurrentUser: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Email: PropTypes.string.isRequired,
    Market: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
  }),
  PageTrackingId: PropTypes.string.isRequired,
  Token: PropTypes.string,
  UserPreferences: PropTypes.shape({
    AccountLevelPreferences: PropTypes.string,
    UserLevelPreferences: PropTypes.string,
  }).isRequired,
  McaServiceRoot: PropTypes.string.isRequired,
  Permissions: PropTypes.objectOf(PropTypes.bool),
});
